import React, { useEffect, useState } from "react";
import "./Gallery.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const res = await fetch(`${API}/api/gallery`);
        const data = await res.json();
        setImages(Array.isArray(data) ? data : []);
      } catch {
        setImages([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const cats = ["all", ...new Set(images.map((i) => i.category).filter(Boolean))];
  const view = category === "all" ? images : images.filter((i) => i.category === category);

  const openLb = (img) => { setSelected(img); document.body.style.overflow = "hidden"; };
  const closeLb = () => { setSelected(null); document.body.style.overflow = "auto"; };
  const step = (dir) => {
    const idx = view.findIndex((i) => i._id === selected._id);
    const next = dir === "next" ? (idx + 1) % view.length : (idx - 1 + view.length) % view.length;
    setSelected(view[next]);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (!selected) return;
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowRight") step("next");
      if (e.key === "ArrowLeft") step("prev");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [selected, view]); // eslint-disable-line

  return (
    <div>
      <section className="rk-hero">
        <div className="rk-hero-inner">
          <div className="rk-crumb">मुख्यपृष्ठ / छायाचित्रे</div>
          <h1 className="rk-hero-title">छायाचित्र दालन</h1>
          <p className="rk-hero-sub">गावातील कार्यक्रम, सण-उत्सव, विकासकामे व सुविधांची क्षणचित्रे.</p>
        </div>
      </section>

      <section className="rk-wrap" style={{ paddingTop: 36, paddingBottom: 20 }}>
        {cats.length > 1 && (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 26 }}>
            {cats.map((c) => (
              <button key={c} className={`rk-chip ${category === c ? "active" : ""}`} onClick={() => setCategory(c)}>{c === "all" ? "सर्व" : c}</button>
            ))}
          </div>
        )}

        {loading ? (
          <p className="rk-loading">गॅलरी लोड होत आहे...</p>
        ) : view.length === 0 ? (
          <p className="rk-empty">या विभागात कोणतेही फोटो उपलब्ध नाहीत</p>
        ) : (
          <div className="rk-cols rk-cols-3">
            {view.map((img) => (
              <div key={img._id} className="rk-gal-tile" onClick={() => openLb(img)}>
                <img src={img.image} alt={img.caption || "गॅलरी"} loading="lazy" />
                {img.caption && (
                  <div className="rk-gal-cap"><span>{img.caption}</span></div>
                )}
              </div>
            ))}
          </div>
        )}
      </section>

      {selected && (
        <div className="rk-lb" onClick={closeLb}>
          <button className="rk-lb-close" onClick={closeLb}>✕</button>
          <button className="rk-lb-nav rk-lb-prev" onClick={(e) => { e.stopPropagation(); step("prev"); }}>‹</button>
          <div className="rk-lb-body" onClick={(e) => e.stopPropagation()}>
            <img src={selected.image} alt={selected.caption || "गॅलरी"} />
            {selected.caption && <div className="rk-lb-cap">{selected.caption}</div>}
          </div>
          <button className="rk-lb-nav rk-lb-next" onClick={(e) => { e.stopPropagation(); step("next"); }}>›</button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
